module.exports = __webpack_public_path__ + "img/domain.00571008.png";